import { IClientBanner } from '@common/interfaces/client'
import { combineReducers } from 'redux'
import { loadingArrayReducer } from '../../helpers/helpers'
import { createLoadingDataReducer } from '../../helpers/redux'
import { ILoadingData } from '../types'
import {
  CREATE_CLIENT_BANNER_REQUEST,
  DELETE_CLIENT_BANNER_REQUEST,
  EXPIRE_CLIENT_BANNER_REQUEST,
  LIST_CLIENT_BANNERS_REQUEST,
  UPDATE_CLIENT_BANNER_REQUEST,
  prefix,
} from './actions'

export interface IClientBannersData {
  data: IClientBanner[]
  totals: {
    totalItems: number
  }
}

export interface IClientBannersState {
  loadingArray: string[]
  banners: ILoadingData<IClientBannersData>
}

export default combineReducers({
  loadingArray: loadingArrayReducer([prefix]),
  banners: createLoadingDataReducer<IClientBannersData>(
    [LIST_CLIENT_BANNERS_REQUEST],
    [
      CREATE_CLIENT_BANNER_REQUEST,
      UPDATE_CLIENT_BANNER_REQUEST,
      EXPIRE_CLIENT_BANNER_REQUEST,
      DELETE_CLIENT_BANNER_REQUEST,
    ],
  ),
})
